import React from "react";

const Avatar = ({ name, imageUrl }) => {
  const getInitials = (fullName) => {
    //if name not available return
    if (!fullName) return "";

    const nameParts = fullName.trim().split(" ");
    // Get the first initial of the first and last name, if available
    const initials =
      nameParts[0].charAt(0) +
      (nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0) : "");
    return initials.toUpperCase();
  };

  const initials = getInitials(name);

  return (
    <div className="avatar-photo">
      {imageUrl ? <img src={imageUrl} alt={name} /> : initials}
    </div>
  );
};

export default Avatar;
